<template>

		<div class="comments">
      <van-row>
        <van-col span="24" class="my_report_cont"> {{ $t('column.Report_center')}} </van-col>
        <van-col span="22" offset="1" class="my_report_cont_type">
          <van-col span="7" offset="1" v-for="report in list" :key="report.id" :class="[isShow == report.id ? 'my_report_cont_type_bor_a' :'my_report_cont_type_bor']" @click="report_cont_type(report.id)">
            {{report.title}}
          </van-col>
          <van-col span="24" class="my_report_cont_type_text">
            <van-field
              v-model="content"
              rows="5"
              autosize
              type="textarea"
              maxlength="100"
              :placeholder="$t('placeholder.Please_explain_other_reasons')"
              show-word-limit
            />
          </van-col>
          <van-col span="24" class="my_report_cont_img_name">{{ $t('column.Upload_photo_evidence')}} <span>（ {{ $t('column.Up_to_three_pictures')}}）</span></van-col>
          <van-col span="24">
            <van-col span="8" v-for="(t, index) in user_img" :key="t.img" class="my_information_photo">
              <van-image height="6em" :src="t.img" />
              <div class="my_information_photo_del"><van-icon name="cross" @click="photo_del(index)"/></div>
            </van-col>
            <!-- 照片墙按钮 -->
            <van-col span="8" class="my_information_photo" v-if="user_img.length < 3">
              <img src="../assets/img/upd.png"  class="my_information_photo_img" @click="img_upload('img')">
            </van-col>
          </van-col>
          <van-col span="18" offset="3" @click="report_btn" class="my_report_cont_btn">{{ $t('btn.submit')}}</van-col>
        </van-col>
      </van-row>
		</div>

</template>

<script>
  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import { Toast } from 'vant'
	import axios from 'axios'
  export default {
  data() {
    return {
      isShow:'0',
      list:[],
      user_img: [],
      content:'',
    }
  },
	created: function() {
		this.convert()
		document.title = this.$t('title.to_report')
	},
  mounted() {
   // 将要给原生调用的方法挂载到 window 上面
   window.getValueFromApp = this.getValueFromApp
  },
  methods: {
    img_upload (name) {
      // 上传头像
      this.mobile_intercept(name)
    },
    mobile_intercept(name) {
      //  拦截
      const isIos = judgeIosAndroid();
      if (isIos == true) {
        // ios传值方法postMessage（val）传值方式
        window.webkit.messageHandlers.upload_avatar.postMessage(name)
      } else {
        // ios传值方法goSubmitted（val）传值方式
        window.AndroidJs.upload_avatar(name)
      }
    },
    getValueFromApp(name,url) {
      // 上传回调
      // 下载完成回调(ios和android调用接口)
      if (name === 'img') {
        const imgs = {'img': url, status: 1}
        this.user_img.push(imgs)
      }
    },
    photo_del (index) {
      // 删除图片
      this.user_img.splice(index, 1);
    },
		convert: function() {
			axios.get(this.baseUrlApi+"mapi/public/index.php/api/page_data_api/get_report_type").then(res =>{
				 console.log(res);
				 this.list = res.data.list;
			})
		},
		report_btn() {
			const uid = this.$route.query.uid
			const token = this.$route.query.token
			const touid = this.$route.query.touid
      let imgs = ''
      for ( let i=0; i < this.user_img.length; i++) {
        imgs += i === 0 ? this.user_img[i].img : ',' + this.user_img[i].img
      }
			axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_do_report_user", {
				params: {
					uid: uid,
					token: token,
          to_user_id:touid,
					type:this.isShow,
          content:this.content,
					img: imgs,
				}
			}).then(res => {
				console.log(res);
        Toast(res.data.msg)
				if(res.data.code == 1) {
					this.convert()
				}
			})
		},
		report_cont_type(id) {
      this.isShow = id
		}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/to_report.vue